import * as yup from 'yup';
import { Client } from 'store/clients';
import { validateText } from 'utils/validation';
import { INVALID } from './constants';

export const getInitialForm = (client?: Client) => ({
  name: client ? client.name : '',
  configuration: client ? client.configuration : {}
});

export const clientValidationSchema = yup.object().shape({
  name: validateText()
});

export const getHasEmptyInput = (form: ReturnType<typeof getInitialForm>) => {
  return Object.values(form).some((value) => value === '');
};

export const getHasInvalidInput = (validation: { [x: string]: string }) => {
  const tempValidation = validation;
  return Object.values(tempValidation).some((value) => value === INVALID);
};
